// extracted by mini-css-extract-plugin
export default {"form":"fibonacci-page_form__56vBH","wrapper":"fibonacci-page_wrapper__cIZdv","series":"fibonacci-page_series__Nee1E"};